module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100"
  }, [(_vm.reservation.billing && _vm.audienceTypes) ? _c('div', {
    staticClass: "h-100 d-flex flex-column py-2",
    class: {
      'opacity-50': !_vm.checkinAllowed
    }
  }, [_c('div', {
    staticClass: "d-flex flex-grow-1 flex-column px-3"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between border-bottom-medium pb-2"
  }, [_c('div', {
    staticClass: "dark pt-2 fs-large font-weight-600"
  }, [_vm._v("\n                    Check-In\n                ")]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.decrementCheckin
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.paxCheckedIn),
      expression: "reservation.paxCheckedIn"
    }, {
      name: "numInt",
      rawName: "v-numInt"
    }],
    staticClass: "text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-2",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "value": "0"
    },
    domProps: {
      "value": (_vm.reservation.paxCheckedIn)
    },
    on: {
      "blur": _vm.checkinBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "paxCheckedIn", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.incrementCheckin
    }
  }, [_vm._v(" + ")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('div', {
    staticClass: "dark pt-2 fs-large font-weight-600"
  }, [_vm._v("\n                    No-Show\n                ")]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.decrementNoShow
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.paxNoShow),
      expression: "reservation.paxNoShow"
    }, {
      name: "numInt",
      rawName: "v-numInt"
    }],
    staticClass: "text-center fs-large darker bg-lighter border-medium radius-normal px-1 py-1 mx-2",
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "value": "0"
    },
    domProps: {
      "value": (_vm.reservation.paxNoShow)
    },
    on: {
      "blur": _vm.noShowBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "paxNoShow", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn fs-large bg-lightest dark border-medium py-0 px-2 h-100",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.incrementNoShow
    }
  }, [_vm._v(" + ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [(_vm.totalPax == 0) ? _c('span', {
    staticClass: "bold dark",
    on: {
      "click": _vm.checkAllIn
    }
  }, [_vm._v("No Pax selected")]) : (!_vm.allChecked) ? _c('button', {
    staticClass: "btn tertiary",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.checkAllIn
    }
  }, [_vm._v("Check-in All")]) : (_vm.allChecked) ? _c('button', {
    staticClass: "btn tertiary",
    class: _vm.checkinAllButton,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.checkAllIn
    }
  }, [_vm._v("All checked "), _c('i', {
    staticClass: "ico ico-check mr-0 ml-2"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.checkinAllowed) ? _c('div', {
    staticClass: "py-2 text-center"
  }, [(_vm.isReservationReadOnly) ? _c('span', [_vm._v("Booking read only")]) : (_vm.totalDue > 0) ? _c('span', [_vm._v("Booking not paid")]) : _vm._e()]) : _vm._e()]) : _c('div', {
    staticClass: "dark text-center m-3"
  }, [_c('div', {
    staticClass: "fs-large darker"
  }, [_vm._v("Loading")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-428afcc8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428afcc8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabReservation/Checkins.vue
// module id = 1915
// module chunks = 0